module.exports = __webpack_public_path__ + "static/media/blog_55.bca0ecba.webp";